"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "./tags.model";
export let AccountAuthSessionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.type = "";
    this.token = "";
    this.name = "";
    this.account = "";
    this.permissions = new TagsModel();
    this.mark = new TagsModel();
    this.need_pin_verify = false;
    this.message = "";
  }
};
AccountAuthSessionModel.model = "account.auth.session";
AccountAuthSessionModel = __decorateClass([
  Annotation.ModelMeta
], AccountAuthSessionModel);
export let AccountSessionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.token = "";
    this.account = "";
    this.name = "";
    this.type = "";
    this.org_id = "";
    this.org_name = "";
    this.role_name = "";
    this.permissions = new TagsModel();
    this.marks = new TagsModel();
  }
  get mark() {
    return this.marks;
  }
};
AccountSessionModel.model = "account.session";
AccountSessionModel = __decorateClass([
  Annotation.ModelMeta
], AccountSessionModel);
export let SessionStorageModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.value = {};
  }
};
SessionStorageModel.model = "storage.user";
SessionStorageModel = __decorateClass([
  Annotation.ModelMeta
], SessionStorageModel);
